import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { AuthGuard } from '../../Guards/AuthGuard';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { VehiclesAddComponent } from './vehicles/vehicles-add/vehicles-add.component';
import { UsersAddComponent } from './users/users-add/users-add.component';
import { JustificationsAddComponent } from './justifications/justifications-add/justifications-add.component';
import { JustificationsComponent } from './justifications/justifications.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompaniesAddComponent } from './companies/companies-add/companies-add.component';
import { PlantsComponent } from './plants/plants.component';
import { PlantsAddComponent } from './plants/plants-add/plants-add.component';
import { WarehousesComponent } from './warehouses/warehouses.component';
import { WarehousesAddComponent } from './warehouses/warehouses-add/warehouses-add.component';
import { ProvidersComponent } from './providers/providers.component';
import { ProvidersAddComponent } from './providers/providers-add/providers-add.component';
import { AuthRejectComponent } from './auth-reject/auth-reject.component';
import { AuthRejectAddComponent } from './auth-reject/auth-reject-add/auth-reject-add.component';
import { ShipsComponent } from './ships/ships.component';
import { ShipsAddComponent } from './ships/ships-add/ships-add.component';
import { InventaryComponent } from './inventary/invetnary.component';
import { InventaryAddComponent } from './inventary/inventary-add/inventary-add.component';

const routes: Routes = [
  { path: '', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'users/add', component: UsersAddComponent, canActivate: [AuthGuard] },
  { path: 'users/edit/:id', component: UsersAddComponent, canActivate: [AuthGuard] },
  { path: 'vehicles', component: VehiclesComponent, canActivate: [AuthGuard] },
  { path: 'vehicles/add', component: VehiclesAddComponent, canActivate: [AuthGuard] },
  { path: 'vehicles/edit/:id', component: VehiclesAddComponent, canActivate: [AuthGuard] },
  { path: 'justifications', component: JustificationsComponent, canActivate: [AuthGuard] },
  { path: 'justifications/add', component: JustificationsAddComponent, canActivate: [AuthGuard] },
  { path: 'justifications/edit/:id', component: JustificationsAddComponent, canActivate: [AuthGuard] },
  { path: 'companies', component: CompaniesComponent, canActivate: [AuthGuard] },
  { path: 'companies/add', component: CompaniesAddComponent, canActivate: [AuthGuard] },
  { path: 'companies/edit/:id', component: CompaniesAddComponent, canActivate: [AuthGuard] },
  { path: 'plants', component: PlantsComponent, canActivate: [AuthGuard] },
  { path: 'plants/add', component: PlantsAddComponent, canActivate: [AuthGuard] },
  { path: 'plants/edit/:id', component: PlantsAddComponent, canActivate: [AuthGuard] },
  { path: 'warehouses', component: WarehousesComponent, canActivate: [AuthGuard] },
  { path: 'warehouses/add', component: WarehousesAddComponent, canActivate: [AuthGuard] },
  { path: 'warehouses/edit/:id', component: WarehousesAddComponent, canActivate: [AuthGuard] },
  { path: 'providers', component: ProvidersComponent, canActivate: [AuthGuard] },
  { path: 'providers/add', component: ProvidersAddComponent, canActivate: [AuthGuard] },
  { path: 'providers/edit/:id', component: ProvidersAddComponent, canActivate: [AuthGuard] },
  { path: 'authReject', component: AuthRejectComponent, canActivate: [AuthGuard] },
  { path: 'authReject/add', component: AuthRejectAddComponent, canActivate: [AuthGuard] },
  { path: 'authReject/edit/:id', component: AuthRejectAddComponent, canActivate: [AuthGuard] },
  { path: 'ships', component: ShipsComponent, canActivate: [AuthGuard] },
  { path: 'ships/add', component: ShipsAddComponent, canActivate: [AuthGuard] },
  { path: 'ships/edit/:id', component: ShipsAddComponent, canActivate: [AuthGuard] },
  { path: 'inventary', component: InventaryComponent, canActivate: [AuthGuard] },
  { path: 'inventary/add', component: InventaryAddComponent, canActivate: [AuthGuard] },
  { path: 'inventary/edit/:id', component: InventaryAddComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogsRoutingModule {
}
